import { Translation } from '@shared/types/translation';

export const CERTIFICATE_LABELS = {
  CERTS_LIST_EMPTY_TITLE: {
    english: 'No certificates available yet.',
    polish: 'Brak dostępnych certyfikatów.',
  },
  TECHNICIAN_MY_CERTS_EMPTY_DESCRIPTION: {
    english:
      'Once certificates are assigned by the admin, they will be displayed here.',
    polish:
      'Certyfikaty przypisane przez administratora pojawią się w tym miejscu.',
  },
  ADMIN_CERTS_LIST_EMPTY_DESCRIPTION: {
    english:
      'Certificates generated from completed service tasks will appear here.',
    polish:
      'Certyfikaty wygenerowane z ukończonych zadań serwisowych pojawią się w tym miejscu.',
  },
  CLIENT_CERTS_LIST_EMPTY_DESCRIPTION: {
    english: 'Once certificates are generated, they will be displayed here.',
    polish: 'Po wygenerowaniu certyfikatów pojawią się one w tym miejscu.',
  },
  VIEW_CERT_DETAILS_TITLE: {
    english: 'Certificate Details',
    polish: 'Szczegóły certyfikatu',
  },
  // Shared by LIST_COL_TEMPLATE_ID and VIEW_FIELD_TEMPLATE_ID in the legacy
  // labels.ts — both are the identical "Template ID" column/field label.
  TEMPLATE_ID_LABEL: {
    english: 'Template ID',
    polish: 'ID szablonu',
  },
  // Shared by LIST_COL_TASK_FORM_ID and VIEW_FIELD_TASK_FORM_ID in the legacy
  // labels.ts — both are the identical "Task Form ID" column/field label.
  TASK_FORM_ID_LABEL: {
    english: 'Task Form ID',
    polish: 'ID formularza zadania',
  },
  VIEW_PAGE_TITLE: {
    english: 'View Certificate Template',
    polish: 'Podgląd szablonu certyfikatu',
  },
  FIELD_SUBTITLE: {
    english: 'Subtitle (Optional)',
    polish: 'Podtytuł (Opcjonalne)',
  },
  CREATE_SUCCESS: {
    english: 'Certificate template added successfully.',
    polish: 'Szablon certyfikatu został dodany.',
  },
  STALE_FIELDS_ERROR: {
    english:
      'Some selected form fields are no longer available. Please reselect the fields.',
    polish:
      'Niektóre wybrane pola formularza nie są już dostępne. Wybierz pola ponownie.',
  },
  CERTS_EXPORT_EMPTY_TOOLTIP: {
    english: 'No certificates available to export.',
    polish: 'Brak certyfikatów dostępnych do eksportu.',
  },
} as const satisfies Record<string, Translation>;
